import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app-icon-snapshot",
  "use": "app-icon-snapshot-usage",
  "viewBox": "0 0 16 15",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 15\" id=\"app-icon-snapshot\"><path d=\"M16 15H0V2h3.38l1-2h7.24l1 2H16v13zM2 13h12V4h-2.62l-1-2H5.62l-1 2H2v9zm6-1a4 4 0 110-8 4 4 0 010 8zm0-6a2 2 0 100 4 2 2 0 000-4z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol